/* eslint-disable import/no-deprecated */
import { cloneDate, isSameDate } from '@fullstory/util/date';
import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { Box } from '../../legacy/Box';
import { Column, Container } from '../../legacy/Column';
import { Typography } from '../Typography';
import { Header } from './Header';
import css from './index.module.scss';
import { MonthView } from './MonthView';

interface MonthScrollerProps
  extends Omit<React.ComponentProps<typeof MonthView>, 'date' | 'outOfMonth'> {
  /** Initial date to show selected */
  initialVisibleDate?: Date;
}

/**
 * @deprecated
 */
export const MonthScroller: React.FC<MonthScrollerProps> = ({
  initialVisibleDate = new Date(),
  highlighted,
  ...rest
}) => {
  const intl = useIntl();
  const [viewDate, setViewDate] = useState<Date>(initialVisibleDate);

  const localizedDays = [...Array(7).keys()].map(day =>
    intl.formatDate(new Date(Date.UTC(2021, 5, day)), { weekday: 'short' }),
  );

  const previousMonth = () => {
    const d = cloneDate(viewDate);
    d.setMonth(viewDate.getMonth() - 1);
    setViewDate(d);
  };
  const nextMonth = () => {
    const d = cloneDate(viewDate);
    d.setMonth(viewDate.getMonth() + 1);
    setViewDate(d);
  };

  const outOfMonth = useCallback((d: Date) => d.getMonth() != viewDate.getMonth(), [viewDate]);
  const sameDay = useCallback((d: Date) => isSameDate(new Date(), d), []);

  return (
    <Box data-component="DeprecatedDatepickerMonthScroller" width={240} padding={8}>
      <Header date={cloneDate(viewDate)} onPreviousClick={previousMonth} onNextClick={nextMonth} />
      <Container gapless>
        {localizedDays.map(d => (
          <Column key={d} className={css.dayName}>
            <Typography variant="heading7" color="neutrals-n7">
              {d}
            </Typography>
          </Column>
        ))}
      </Container>
      <MonthView
        date={viewDate}
        outOfMonth={outOfMonth}
        highlighted={highlighted || sameDay}
        {...rest}
      />
    </Box>
  );
};
